
export default {
	// name: 'collapse-indicator',
	props: ['open', 'loading'],
}
